<template>
  <div id="login">
    <div class="row w-100" style="padding-left: 20%; padding-right: 20%">
      <div class="col-12 col-sm-2 col-lg-3"></div>
      <div class="col-12 col-sm-8 col-lg-6">
        <div class="shadow" style="min-height: 50vh; border-radius: 3%; padding: 50px">
          <div class="mb-5" style="display: flex; flex-direction: row; justify-content: center">
            <img src="@/assets/img/Logo/AHM Logo New.png" class="img-static" style="width: 250px" />
          </div>

          <form @submit.prevent="login()">
            <div class="form-group">
              <label class="labelForm">User Name</label>
              <input type="text" class="form-control" v-model="form.username" />
            </div>
            <div class="form-group mt-5">
              <label class="labelForm">Password</label>
              <input type="password" class="form-control" v-model="form.password" />
            </div>
            <div class="mb-3">
              <input type="checkbox" name="remember_me" class="" />
              Ingatkan Saya
            </div>

            <div class="form-group text-center mt-5">
              <!-- <button class="btn btn-primary w-50">Login</button> -->
              <button class="btn ahmoil-button" @click="login">Login</button>
            </div>
            <!-- <div class="form-group text-center" style="font-size:15px">
							<a href="#" style="color:grey">Forgot Password ?</a>
						</div> -->
          </form>
        </div>
        <!-- <div class="row mt-3 text-center" style="color:grey;font-size:15px">
					<div class="col-6">
						Terms &amp; Conditions
					</div>
					<div class="col-6">
						Privacy Policy
					</div>
				</div> -->

        <!-- <div class="row mt-4">
					<div class="col-md-5 col-5" style="border-bottom: 1px solid grey"/>
					<div class="col-md-2 col-2 text-center"><span style="font-size:14px;color:grey">or</span></div>
					<div class="col-md-5 col-5" style="border-bottom: 1px solid grey"/>
				</div> -->
      </div>
      <div class="col-12 col-sm-2 col-lg-3"></div>
    </div>

    <div class="footerLogin">&copy; 2021 AHM OIL, All Rights Reserved</div>
  </div>
</template>

<script type="text/javascript">
import PageOptions from "@/Options/PageOptions.js";
import jquery from "jquery";

export default {
  metaInfo: {
    title: "Login",
    titleTemplate: "AHM OIL Dashboard - %s",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  name: "Login",
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      error: "",
      mobile: this.isMobile(),
    };
  },
  mounted() {},
  methods: {
    login: function () {
      this.$http
        .post("/api/sso/login", this.form)
        .then((resp) => {
          this.error = "";
          var user = resp.data.data;
          // console.log(resp)

          this.$http.defaults.headers.common["Authorization"] = "Bearer " + user.token;
          user.name = this.form.username;

          // const companyDetails = {
          //   company : companyName,
          //   companyLogo : companyLogo
          // }

          this.$store.dispatch("setUser", user);
          // this.$store.dispatch('setCompanyDetails', companyDetails);
        })
        .then(async () => {
          // let modules = await this.getModules();
          await this.loadFilterOptions();
          //NAVIGATION WILL BE HANDLED INSIDE LOADFILTER OPTIONS

          // console.log(modules ? 'Modules Successfully Loaded' : 'Modules Has Failed To Load');
        })
        .then(() => {
          // var user = this.$store.getters.currentUser
          // var allowed_roles = ['ADMIN']
          // if (
          // 	user.permissions.indexOf('form.home.fullAccess') != -1 ||
          // 	user.role.length == 0 ||
          // 	user.role[0].id == 1
          // )
          // 	this.$router.push({name : 'Homepage'})
          // else if (user.role[0].id == 2) {
          // 	this.$router.push({name : 'WorkOrderListing'})
          // } else
          // 	this.$router.push({name : 'Welcome'})
          // this.$router.push({name : 'HighlightLabelMaker'});
        })
        .catch((err) => {
          console.log(err);
          this.$swal.fire({
            title: "Error!",
            icon: "error",
            type: "error",
            text: err.response.data.message,
          });
        });

      // this.$store.dispatch('setUser', {
      //   user_id: 2,
      //   username: 'andre',
      //   fullname: 'Andre',
      //   role: 'ADMINISTRATOR',
      // });
      // this.$router.push({name : 'Highlight'});
    },
  },
};
</script>

<style scoped>
#login {
  height: 100vh;
  background: #c54245;
  /* background : url('~@/assets/img/Logo/background2.png')no-repeat center center fixed;  */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 100% auto;
  position: relative;
  overflow-y: hidden;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

.shadow {
  background: #fff;
  /* height: 10px; */
}

.h-10 {
  height: 10% !important;
}

.toCenter {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.wid50 {
  width: 50vw;
}

.wid90 {
  width: 90vw;
}

#loginShade {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  height: 400px;

  margin: 0 auto;

  background-color: #000;
  opacity: 0.5;
  border-radius: 7px;
}

#loginBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  height: 400px;

  margin: 0 auto;
  padding: 2%;
  color: white;
}

.login-input {
  height: 50px;
}

.login-input::placeholder {
  font-size: 130%;
  font-weight: bold;
}

.labelForm {
  font-size: 15px;
  font-weight: 600;
  color: #575757;
}

.form-control {
  border: 0;
  outline: 0;
  border-bottom: 2px solid #ddd;
  border-radius: 0;
  padding: 0;
  font-size: 1rem;
}

.form-control:focus {
  border: 0 !important;
  outline: 0 !important;
  box-shadow: 0 1px 1px #fff inset;
  border-bottom: 2px solid #1f6dbb !important;
  border-radius: 0;
  transition: all 0.7s ease;
}

.footerLogin {
  position: fixed;
  left: 50%;
  bottom: 20px;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  color: grey;
  font-size: 11px;
}

.ahmoil-button {
  width: 100%;
  height: 40px;
  background: #ec1a30;
  color: white;
  font-size: 125%;
}

.footerLogin {
  color: white;
}
</style>
